
import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import _ from "lodash";
import { useStyle } from "../style";
import { Helmet } from "react-helmet-async";
import { Close, Delete, ExitToApp, Save, Visibility } from "@mui/icons-material";
import moment from "moment";
// import TempData from "./tempData";
import CloseIcon from "@mui/icons-material/Close";
import { debounce } from 'lodash';
import { makeStyles } from '@mui/styles';
import ReactMemo from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import DialogCancel from "../../../../../components/utils/dialogCancel/dialogCancel";
import { useNavigate } from "react-router-dom";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import Modal from "../../../../../components/utils/modal/modal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

const CloseStockOtPending = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  
  const [catData, setCatData] = useState([]);
  const [allSubData, setAllSubData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [itemData, setItemData] = useState(null);
  const [qty, setQty] = useState("");
  const [salesMan, setSalesMan] = useState([]);
  const [tempData, setTempData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [barcode, setBarcode] = useState(''); // State to store the barcode value
  const [options, setOptions] = useState({
    category: null,
    subCategory: null,
    salesManId: null,
  });
      const [supplier, setSupplier] = useState([]);
  
  const [postData, setPostData] = useState({
    // closing_data_outlet: [],
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const roleId = localStorage.getItem("role_id")
  const [data, setData] = useState([]);
  const [code, setCode] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const codeRef = useRef(null);
  const [count, setCount] = useState(0);
  const outletId = localStorage.getItem("outlet_id");
  const [isPendingDisabled, setIsPendingDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(100); // Set the rows per page
  const [rateData, setRateData] = useState({
    mrp: "",
    disc: "",
    rate: "",
    gst: "",
    qty: "",
  });
    const [dialogClose, setDialogClose] = useState(false);
  
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [page, setPage] = useState(0);
  const pageCount = Math.ceil(tempData.length / rowsPerPage);
  const qtyRef = useRef(null);
  const tableRef = useRef(null);
  // function handleChangeValue(value, name) {
  //   codeRef.current.focus()
  //   setOptions((prev) => ({ ...prev, [name]: value }));
  //   setCount(0);
  //   if (name === "category") {
  //     setOptions((prev) => ({ ...prev, subCategory: null }));
  //     filterSubCategories(value ? value.id : null);
  //   }
  // }
    const navigate = useNavigate();
  const openDialog = () => {
    setIsDialogOpen(true);
};

  // function handleChangeValue(value, name) {
  //   if (codeRef.current) {
  //     codeRef.current.focus();
  //   }
  //   setOptions((prev) => ({ ...prev, [name]: value }));
  //   setCount(0);
  
  //   if (name === "category") {
  //     setOptions((prev) => ({ ...prev, subCategory: null }));
  //     filterSubCategories(value ? value.id : null);
  //   }
  // }
  function handleChangeValue(value, name) {
  if (codeRef.current) {
    codeRef.current.focus();
  }

  setOptions((prev) => ({
    ...prev,
    [name]: value,
  }));
  setCount(0);

  if (name === "category") {
    setOptions((prev) => ({
      ...prev,
      subCategory: null,
    }));
    filterSubCategories(value ? value.id : null);
  }

  if (name === "outletId") {
    getSalesMan(value?.id);
    getTempDetails(value?.id);
    getPendingDetails(value?.id);
  }
}

  function getCategory() {
    axios
      .get("/v1/categories")
      .then((res) => {
        const activeCategories = _.filter(res.data, (val) => val.is_active);
        setCatData(activeCategories);
      })
      .catch((err) => {
        // console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  function getSubCategory() {
    axios
      .get("/v1/subcategories")
      .then((res) => {
        setAllSubData(res.data);
      })
      .catch((err) => {
        // console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getSalesMan() {
    const outletId = options?.outletId || localStorage.getItem("outlet_id"); // Retrieve outlet ID from options or localStorage

    axios
      .get(`/v1/SalesMan/outlets/${outletId}`)
      .then((res) => setSalesMan(res.data))
      .catch((err) => {
        // console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  console.log(options,"options1122");
  
  function getTempDetails() {
    setLoading(true);
    const category = options.category != null ? options.category.id : 0
    const subcategories = options.subCategory != null ? options.subCategory.id : 0
    const outletid = options.outletId != null ? options.outletId.id : 0
    axios
      .get(`/v1/closing_stock_outlet/pending/stocks/barcodes/${outletid}/${category}/${subcategories}`)
      .then((res) => {
        setTempData(res.data);
      })
      .catch((err) => {
        
      })
      .finally(()=>{
        setLoading(false);

      });
  }
  function getPendingDetails() {
    // const outletId = options?.outletId || localStorage.getItem("outlet_id"); // Retrieve outlet ID from options or localStorage
    const categoryId = options?.category?.id || 0; // Get category ID, default to 0
    const subCategoryId = options?.subCategory?.id || 0; // Get sub-category ID, default to 0
      const outletid = options.outletId != null ? options.outletId.id : 0

    const url = `/v1/closing_stock_outlet/pending/stocks/barcodes/${outletid}/${categoryId}/${subCategoryId}`;
  
    axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        // console.log(res);
        setPendingData(res.data); // Set pending data
        setIsPendingDisabled(!res.data || res.data.length === 0); // Disable button if response is empty
      })
      .catch((err) => {
        console.error("Error:", err);
        setIsPendingDisabled(true); // Disable button on error
        dispatch(setSnackbar(true, "error", err.response?.data?.error || "Failed to fetch pending details"));
      });
  }

  function filterSubCategories(categoryId) {
    if (categoryId) {
      const filteredSubData = allSubData.filter(
        (sub) => sub.category_id === categoryId
      );
      setSubData(filteredSubData);
    } else {
      setSubData([]);
    }
  }
 function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        setData([]);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  useEffect(() => {
    getCategory();
    getSubCategory();
    getSalesMan();
    getSupplierData()
  }, []);
  useEffect(() => {
    if (options.category) {
      filterSubCategories(options.category.id);
      getTempDetails();
    }
  }, [options.category]);
  useEffect(() => {
    if (options.category !== null && outletId) {
      getTempDetails();
       getPendingDetails()
    }
  }, [options]);
  useEffect(()=>{
    getPendingDetails()

  },[])

  useEffect(() => {
    if (tempData?.length > 0) {
      let arr = [];
      tempData.forEach((val) => {
        const obj = {
          docdate: moment().format("YYYY-MM-DD"),
          physical_qty: 1,
          prodid: val?.prod_id,
          company_id: 1,
          uid:  options.salesManId != null ? options.salesManId.id : 0,
          barcode: val?.barcode,
          outlet_id: outletId,
          cat_id: options.category != null ? options.category.id : 0,
          sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
        };
        arr.push(obj);
      });
  
      // Set the combined data to closing_data_outlet
      setPostData((prevState) => ({
        ...prevState,
        closing_data_outlet: arr,
      }));
    }
  }, [data, tempData, outletId]);
   // Handle page change for pagination
   const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change for pagination
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset to page 0 on rows per page change
  };

  // Memoize the rows for performance optimization
  const rows = useMemo(() => {
    return tempData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [tempData, page, rowsPerPage]);
  console.log(tempData,"tempData");
  
// console.log(tempData,"What is this")
  // console.log(options)
  // console.log(options.subCategory != null && options.subCategory.id)
// TableRow component memoized to prevent unnecessary re-renders
const handleExportExcel = () => {
  const exportData = flattenedRows.map((row, idx) => ({
    Sno: idx + 1,
    Category: row.category_name,
    SubCategory: row.subcategory_name,
    Mrp: row.mrp,
    Qty: row.qty ?? "–",
    Barcode: row.barcode ?? "–",
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Closing Stock");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

  saveAs(dataBlob, "ClosingStockPending.xlsx");
};
const MemoizedTableRow = React.memo(({ value, idx, handleDeleteRow }) => {
  return (
    <>
    <TableRow className={classes.tablrow} key={idx}>
      <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ borderLeft: "0.5px solid  #ccc" }}>
        {idx + 1}
      </TableCell>
      <TableCell>{value?.category_name}</TableCell>
      <TableCell variant="body" cclassName={classes.tblContentCell}>
        {value?.subcategory_name}
      </TableCell>
      <TableCell>{value?.mrp}</TableCell>
      <TableCell>{value?.qty}</TableCell>
     
      
    </TableRow>
        
      </>
  );
});
// after: const rows = useMemo(...);
// after: const rows = useMemo(...)
const flattenedRows = useMemo(() => {
  return rows.flatMap(item => {
    if (item.barcode_list?.length > 0) {
      return item.barcode_list.map((barcode, bIdx) => ({
        category_name:  item.category_name,
        subcategory_name: item.subcategory_name,
        mrp:             item.mrp,
        // only show qty on the very first barcode of this item
        qty:             bIdx === 0 ? item.qty : null,
        barcode,
      }));
    }
    // no barcodes → single “no barcode” row with its own qty
    return [{
      category_name:  item.category_name,
      subcategory_name: item.subcategory_name,
      mrp:             item.mrp,
      qty:             item.qty,
      barcode:         null,
    }];
  });
}, [rows]);


  return (
    <Fragment>
      <Grid className={classes.root}>
        <Helmet><title>Outlet Closing Stock</title></Helmet>
        <Grid >
          <Typography variant="h5" fontWeight={600}>Closing Stock</Typography>
        </Grid>
        <Grid container spacing={2} className="p-3">
          <Grid item xs={12} sm={6} md={4} lg={2}>
         
                    <Autocomplete 
                      size="small"
                      options={[{id:0 , fullname :"All"} , ...supplier]}
                      // onChange={(e,value)=>handleOptions(value,'customer')}
  onChange={(e, value) => handleChangeValue(value, 'outletId')}
                      getOptionLabel={option=>option.fullname}
                      renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
                    />
                  
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Autocomplete
              size="small"
              value={options.category}
              options={catData}
              getOptionLabel={(option) => option.category_name}
              onChange={(e, value) => handleChangeValue(value, "category")}
              renderInput={(params) => (
                <TextField {...params} label="Category" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <Autocomplete
              size="small"
              // options={[{id:0,subcategory_name:"All"}, ...subData]}
              options={subData}
              value={options.subCategory}
              getOptionLabel={(option) => option.subcategory_name}
              onChange={(e, value) => handleChangeValue(value, "subCategory")}
              disabled={options.category == null}
              renderInput={(params) => (
                <TextField {...params} label="Sub Category" />
              )}
            />
          </Grid>
          
                    <Grid item xs={12} sm={6} md={4} lg={4}/>

                    <Button 
  variant="outlined" 
  onClick={handleExportExcel} 
  sx={{ ml: 2, mt: 1 }}
>
 Export to Excel <SimCardDownloadOutlinedIcon />
</Button>
        </Grid>
        {/* <TempData tempData={tempData}/> */}
        <Box position="relative" width="100%" height="100%">


        <Grid className="w-full" sx={{ height: "400px" }}>
          
  <TableContainer className={classes.tblRoot} sx={{ maxHeight: '400px',overflow: "auto", }} ref={tableRef}>
    <Table stickyHeader className={classes.table}>
      <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0 }}>
        <TableRow className={classes.tablrow}>
          <TableCell
            className={classes.tblCell}
            sx={{ borderLeft: "0.5px solid  #ccc" }}
          >
            Sno
          </TableCell>
          <TableCell className={classes.tblCell}>Category</TableCell>
          <TableCell className={classes.tblCell}>SubCategory</TableCell>
          <TableCell className={classes.tblCell}>Mrp</TableCell>
          <TableCell className={classes.tblCell}>Qty</TableCell>
          <TableCell className={classes.tblCell}>BarCode</TableCell>
        </TableRow>
      </TableHead>
   
<TableBody>
  {flattenedRows.map((row, i) => (
    <TableRow key={i} className={classes.tablrow}>
      <TableCell
        padding="checkbox"
        className={classes.tblContentCell}
        sx={{ borderLeft: "0.5px solid #ccc" }}
      >
        {i + 1}
      </TableCell>

      <TableCell>{row.category_name}</TableCell>
      <TableCell className={classes.tblContentCell}>
        {row.subcategory_name}
      </TableCell>
      <TableCell>{row.mrp}</TableCell>

      {/* show qty or a dash if null */}
      <TableCell>
        {row.qty != null ? row.qty : "–"}
      </TableCell>

      {/* show barcode or a dash if null */}
      <TableCell>
        {row.barcode ?? "–"}
      </TableCell>
    </TableRow>
  ))}
</TableBody>


    </Table>

    {/* Pagination Footer */}


  </TableContainer>
  <div className={classes.pagination} 
    //  style={{ position: "absolute", bottom: 0, width: "100%",backgroundColor: "white",  }}
    style={{ width: "100%",backgroundColor: "white",  }}

     >
      <TablePagination 
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={tempData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        pageCount={pageCount}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelDisplayedRows={({ from, to, count }) => {
          const pageCount = Math.ceil(count / rowsPerPage); // Calculate the page count
          return `${page + 1}`; // Custom format with "< 1 >"
        }}
      />
    </div>
 
</Grid>

       

            {/* Loader Overlay */}
            {loading && (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            position="absolute" 
            top={0} 
            left={0} 
            right={0} 
            bottom={0} 
            bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
            zIndex={10}
          >
            <CircularProgress size={50}/> {/* Material UI spinner */}
          </Box>
        )}
        </Box>
    
      </Grid>

    </Fragment>
  );
};

export default CloseStockOtPending;
